import { render } from "./Sidebar.vue?vue&type=template&id=79755744"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=79755744&lang=css"

import exportComponent from "/Users/home/Projects/creelayer/mosquito/mosquito.web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__